import { useEffect } from "react"

import { usePostHog } from "posthog-js/react"

import { useAnalytics } from "@/lib/analytics"

export function useWorkspacePostHogGroup(
  organizationId: string | null,
  workspaceId: string | null,
): void {
  const posthogClient = usePostHog()
  const { group } = useAnalytics()

  useEffect(() => {
    if (!posthogClient) {
      return
    }
    if (workspaceId === null) {
      posthogClient.resetGroups()
      if (organizationId !== null) {
        group("organization", organizationId)
      }
    } else {
      group("workspace", workspaceId)
    }
  }, [group, organizationId, posthogClient, workspaceId])
}
